import React from 'react'

const Content = () => {
debugger

    return (
        <div>
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Məlumat</h1>
                            </div>
                            {/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">v1</li>
                                </ol>
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        {/* Small boxes (Stat box) */}
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-info">
                                    <div className="inner">
                                        <h3>15</h3>
                                        <p>Məhsul Sayı</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-home"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <h3>3<sup style={{fontSize: 20}}></sup></h3>
                                        <p>Bloglar</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-stats-bars"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-warning">
                                    <div className="inner">
                                        <h3>44</h3>
                                        <p>Müştərilər</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-danger">
                                    <div className="inner">
                                        <h3>65</h3>
                                        <p>Təlim</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-ios-cog-outline"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-secondary">
                                    <div className="inner">
                                        <h3>65</h3>
                                        <p>Webinar</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-ios-cog"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <h3>65</h3>
                                        <p>Konferensiya</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-ios-cog"/>
                                    </div>
                                    <a href="#" className="small-box-footer">Ətraflı <i
                                        className="fas fa-arrow-circle-right"/></a>
                                </div>
                            </div>
                            {/* ./col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}
export default Content;
